import { type ResponsiveTableColumn } from '@optimization/ssi-common';
import { type ReactElement } from 'react';
import { type VehicleListColumnKey, type VehicleRowItem } from '..';
import StateOfHealthCell from './StateOfHealthCell';

export const renderStateOfHealthCell = ({ vehicle }: VehicleRowItem, showTooltip = true): ReactElement => (
  <StateOfHealthCell
    stateOfHealthAlert={vehicle.stateOfHealthAlert}
    stateOfHealthRatio={vehicle.stateOfHealthRatio}
    isStateOfHealthEstimated={vehicle.isStateOfHealthEstimated}
    showTooltip={showTooltip}
  />
);

export const stateOfHealthColumn: ResponsiveTableColumn<VehicleRowItem, VehicleListColumnKey> = {
  columnTitle: 'SoH',
  textAlign: 'right',
  columnKey: 'stateOfHealth',
  sortable: true,
  render: renderStateOfHealthCell,
};
